import { useStaticQuery, graphql } from "gatsby";
import { ContentTileProps } from "../components/elements/ContentTile/ContentTile";
import { KontentContentHedgehog, KontentContentProgram } from "../types";
import { formatProgram, formatHedgehog } from "./news";

export interface RecentContent {
  programs: ContentTileProps[];
  hedgehog: ContentTileProps;
}

export interface RecentContentQuery {
  programs: {
    nodes: KontentContentProgram[];
    totalCount: number;
  };
  hedgehogs: { nodes: KontentContentHedgehog[] };
}

export const useRecentContent = (): RecentContent => {
  const recentContentData: RecentContentQuery = useStaticQuery(graphql`
    {
      programs: allKontentItemContentProgram(
        sort: { elements: { display_publish_date: { value: DESC } } }
        limit: 7
      ) {
        nodes {
          system {
            id
          }
          elements {
            content_tile {
              value {
                ...kontentContentTile
              }
            }
            display_publish_date {
              value
            }
            url {
              value
            }
            page_metadata__content_category {
              value {
                name
              }
            }
          }
        }
        totalCount
      }
      hedgehogs: allKontentItemContentHedgehog(
        sort: { elements: { display_publish_date: { value: DESC } } }
        limit: 1
      ) {
        nodes {
          system {
            id
          }
          elements {
            content_tile {
              value {
                ...kontentContentTile
              }
            }
            display_publish_date {
              value(formatString: "MMMM D, YYYY")
            }
            document {
              value {
                url
                type
                name
              }
            }
            page_metadata__content_category {
              value {
                name
              }
            }
          }
        }
      }
    }
  `);

  const recentContent = {
    programs: recentContentData.programs.nodes.map(
      formatProgram
    ) as ContentTileProps[],
    hedgehog: recentContentData.hedgehogs.nodes.map(
      formatHedgehog
    )[0] as ContentTileProps,
  };

  return recentContent;
};
